import type { ApiObject } from '@rudderstack/analytics-js'
import type Session from 'supertokens-auth-react/lib/build/recipe/session/recipe'

import type { RouterPath } from '@/models/enums'

export const TrackingEvents = {
  login: 'login',
  logout: 'logout',
  bookTime: 'book_time_click',
  rescheduleTime: 'reschedule_time_click',
  menuBookings: 'menu_bookings_click',
  phoneClick: 'phone_number_click',
} as const

export type TrackingEvent = (typeof TrackingEvents)[keyof typeof TrackingEvents]

export interface IActivityTrackingService {
  trackEvent(eventName: TrackingEvent, data?: ApiObject): void
  trackUserLogin(userData: Session): void
  trackUserLogout(): void
  trackPhoneClick(phoneNumber: string): void
  trackBookButtonClick(buttonId: string): void
  trackRescheduleButtonClick(buttonId: string): void
  trackMenuNavigationClick(menuItem: RouterPath): void
}
